import React from 'react'
import { ImageNode } from '../../types/nodeTypes'
import SkipButton from '../buttons/SkipButton'

export type ImageNodeProps = {
  node: ImageNode
  onNextCalled: () => void
}

const Image: React.FC<ImageNodeProps> = ({ node, onNextCalled }) => {
  return (
    <div className="layout-node">
      <div className="transcript-container transcript-container-image">
        <div>{node.title}</div>
      </div>
      <div className={`image-layout`}>
        <img alt={node.description} className="full-content-box" src={node.imageUrl ?? ''} />
      </div>
      <div className="transcript-container transcript-container-image">
        <div>{node.description}</div>
      </div>

      <div className="skip-button-layout">
        <SkipButton onClick={onNextCalled} />
      </div>
    </div>
  )
}

export default Image
